import { Component, OnInit, Inject, ViewEncapsulation, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BackLinkService } from '../back-link.service';

@Component({
    selector: 'lupa-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LoginDialogComponent implements OnInit {
    url: string;
    constructor(
        public dialogRef: MatDialogRef<LoginDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private backLinkService: BackLinkService
    ) {}

    @HostListener('window:message', ['$event.data'])
    onMessage(data) {
        if (data && data.connect) {
            // console.log(data);
            this.close(data.connect);
        }
    }

    ngOnInit() {
        if (this.data && this.data.token && this.data.url) {
            this.url = this.data.url + this.data.token;
        }
        this.backLinkService.setCallback(() => {
            this._close();
        });
    }
    close(data?) {
        this._close(data);
        this.backLinkService.clearCallback();
    }
    private _close(data?) {
        this.dialogRef.close(data);
    }
}
